<template>
  <div id="verify-timer">
    <!-- navbar component -->
    <Navbar />
    <div class="container mt-5 mt-md-2">
      <h3 class="txt-title fs-md-5 fs-6 text-center">
        Deposit Verification Time
      </h3>
      <h1 class="txt-title fs-md-1 fs-1 txt-blue text-center">
        {{ timeVerication ? setTimerPayment(timeVerication) : '00 : 00 : 00' }}
      </h1>
      <div class="row mt-5">
        <!-- left side -->
        <!-- if it's not crypto -->
        <div class="col-md-6" v-if="!methodtype">
          <!-- tujuan transfer bank -->
          <div class="mb-3 ml-0">
            <p class="fs-5 fs-md-4 txt-bold m-0">
              Please transfer to:
            </p>
          </div>
          <div class="info-bank p-3 mb-2">
            <p class="fs-md-7 m-0">Transfer Amount:</p>
            <p class="txt-bold fs-md-5 p-0 m-0">
              ${{ paymentID?.amount ? numberWithCommas(paymentID.amount) : '0' }}
            </p>
          </div>
        </div>
        <!-- if its crypto -->
        <div class="col-md-6" v-if="methodtype">
          <div class="bg-light p-3 rounded-primary important-notice-border" v-if="AppConstants?.deposit?.disclaimer?.show">
            <div v-html="AppConstants.deposit.disclaimer.html"></div>
          </div>
          <div class="bg-light p-3 rounded-primary mt-3">
            <p class="txt-bold fs-md-5 mb-1">Important!</p>
            <p class="fs-md-7 m-0">
              Please ensure you send the exact amount to complete your deposit.
              Note that you will need to pay network gas fees when sending from your wallet.
            </p>
          </div>
          <div class="bg_secondary p-3 rounded-primary mt-3">
            <p class="fs-md-7 m-0 mt-2">
              Scan this code below to complete your payment.
              Check again what network you are using to send the payment.
            </p>
            <p class="fs-md-6 text-primary mt-2" v-if="selectedNetwork">
              Selected Network: <strong>{{ selectedNetwork }}</strong>
            </p>
            <!-- Crypto Wallets - Show only selected network by default -->
            <CryptoWallet
              v-show="selectedNetwork === 'ERC20' || showAllNetworks"
              v-if="erc20"
              network-type="ERC20"
              :wallet-address="erc20"
              :qr-image="erc20QrImage"
              :supported-networks="supportedNetworks"
              :amount="paymentID?.amount || 0"
            />

            <CryptoWallet
              v-show="selectedNetwork === 'TRC20' || showAllNetworks"
              v-if="trc20"
              network-type="TRC20"
              :wallet-address="trc20"
              :qr-image="trc20QrImage"
              :supported-networks="supportedNetworks"
              :amount="paymentID?.amount || 0"
            />

            <CryptoWallet
              v-show="selectedNetwork === 'BEP20' || showAllNetworks"
              v-if="bep20"
              network-type="BEP20"
              :wallet-address="bep20"
              :qr-image="bep20QrImage"
              :supported-networks="supportedNetworks"
              :amount="paymentID?.amount || 0"
            />

            <!-- Toggle button to show all networks -->
            <div class="text-center mt-3">
              <button
                class="btn btn-link text-primary"
                @click="showAllNetworks = !showAllNetworks"
              >
                <span v-if="!showAllNetworks">
                  <i class="fa fa-chevron-down mr-2"></i>
                  Show all available networks
                </span>
                <span v-else>
                  <i class="fa fa-chevron-up mr-2"></i>
                  Show selected network only
                </span>
              </button>
            </div>
          </div>
          <p
            class="bg-light fs-md-7 py-3 px-4 mt-3 rounded-primary"
            v-if="AppConstants?.deposit?.unique_code_disclaimer?.show"
            v-html="AppConstants.deposit.unique_code_disclaimer.html"
          ></p>
          <div class="d-none d-md-flex justify-content-between mt-4">
            <router-link to="/dashboard">
              <button class="btn btn_border_primary txt-bold">Back</button>
            </router-link>
          </div>
        </div>
        <!-- right side -->
        <div class="col-md-6">
          <div class="bg-light p-3 rounded-primary">
            <p class="txt-bold fs-md-7 mb-1">DISCLAIMER</p>
            <p class="fs-md-7 m-0">
              1. If you transfer to the wrong address, it will result in
              permanent loss of balance
            </p>
            <p class="fs-md-7 m-0">
              2. Sending coins other than USDT to this address will result in
              permanent balance loss.
            </p>
          </div>
          <!-- Email submission guidance -->
          <h2 class="txt-title fs-md-4 fs-5 mb-md-4 mb-3 mt-3">
            Send Payment Proof
          </h2>

          <div class="bg-light p-3 rounded-primary mt-3">
            <p class="fs-md-7 mb-3">
              After completing your crypto transfer, please reply to that email you receive for requesting deposit with the following information:
            </p>

            <p class="fs-md-7 mb-2">
              <strong>Required Documents:</strong>
              <br>• <strong>Transaction Hash (TxID):</strong> The unique transaction identifier from your crypto wallet
              <br>• <strong>Transaction Screenshot:</strong> A clear screenshot from your wallet showing the completed transaction
              <br>• <strong>Blockchain Explorer Link:</strong> A link to the transaction on the blockchain explorer (optional but recommended)
            </p>

            <p class="fs-md-7 mb-0">
              <strong>Important:</strong> Please ensure all information is clearly visible and matches your deposit request details above.
            </p>
          </div>
          <div class="d-flex d-md-none justify-content-between mt-4">
            <router-link to="/dashboard">
              <button class="btn btn_border_primary txt-bold">Back</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "../components/Navbar.vue";
import CryptoWallet from "../components/CryptoWallet.vue";
import Swal from "sweetalert2";
import cryptoDatabase from "../services/cryptoDatabase";
import Notiflix from "notiflix";
import { AppConstants } from "../const";

// const paymentID = JSON.parse(localStorage.getItem("historyPaymentID"));
const userData = JSON.parse(localStorage.getItem("userData"));

const api_token = process.env.VUE_APP_API_TOKEN;

export default {
  name: "identity",
  components: {
    Navbar,
    CryptoWallet,
  },
  data() {
    return {
      AppConstants,
      historyPayment: null,
      timeVerication: "",
      timeNow: "",
      timeUpdate: "",
      input_file: "",
      expiredTime: "",
      paymentID: JSON.parse(localStorage.getItem("historyPaymentID")),
      login_id: JSON.parse(localStorage.getItem("login_id")),
      getLang: localStorage.getItem("setLang"),
      env: "",
      methodtype: false,
      datamethod: JSON.parse(localStorage.getItem("historyPaymentID")),
      amount: "",
      showAllNetworks: false,
    };
  },
  computed: {
    erc20() {
      return AppConstants.crypto?.addresses?.erc20;
    },
    trc20() {
      return AppConstants.crypto?.addresses?.trc20;
    },
    bep20() {
      return AppConstants.crypto?.addresses?.bep20;
    },
    erc20QrImage() {
      return AppConstants.crypto?.qrImages?.erc20;
    },
    trc20QrImage() {
      return AppConstants.crypto?.qrImages?.trc20;
    },
    bep20QrImage() {
      return AppConstants.crypto?.qrImages?.bep20;
    },
    supportedNetworks() {
      return AppConstants.crypto?.supportedNetworks || [];
    },
    selectedNetwork() {
      return this.paymentID?.crypto?.crypto_type || '';
    }
  },
  mounted() {
    window.scrollTo(0, 0);

    // Check if required payment data exists
    if (!this.paymentID) {
      console.error("No payment data found in localStorage");
      Swal.fire({
        icon: "error",
        title: "No Payment Data",
        text: "No active payment verification found. Redirecting to dashboard...",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        this.$router.push("/dashboard");
      });
      return;
    }

    // Validate crypto configuration exists
    if (!AppConstants.crypto) {
      console.error("CRITICAL: Crypto configuration missing for current grey label");
      return;
    }

    // Debug crypto configuration
    console.log("DEBUG VerifyTimer - AppConstants.crypto:", AppConstants.crypto);
    console.log("DEBUG VerifyTimer - supportedNetworks:", this.supportedNetworks);
    console.log("DEBUG VerifyTimer - selectedNetwork:", this.selectedNetwork);
    console.log("DEBUG VerifyTimer - paymentID crypto data:", this.paymentID?.crypto);
    console.log("DEBUG VerifyTimer - erc20 address:", this.erc20);
    console.log("DEBUG VerifyTimer - trc20 address:", this.trc20);
    console.log("DEBUG VerifyTimer - bep20 address:", this.bep20);
    console.log("DEBUG VerifyTimer - erc20 QR:", this.erc20QrImage);
    console.log("DEBUG VerifyTimer - trc20 QR:", this.trc20QrImage);
    console.log("DEBUG VerifyTimer - bep20 QR:", this.bep20QrImage);

    if (localStorage.getItem("saved_wallet")) {
      this.saved_wallet = localStorage.getItem("saved_wallet");
    }
    if (this.datamethod?.method == "CRYPTO") {
      this.methodtype = true;
    }

    // check apakah token yang dipakai sekarang ini staging apa production
    const apitoken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTUsImV4cGlyZWQiOjE2NDc3Njk3NjIuNjU4LCJpYXQiOjE2MTY2NjU3NjJ9.g8OjvuNsh-8bMuZBmAg7aU_oYcLIALbmLSMIhzbmMYY";
    if (api_token == apitoken) {
      this.env = "staging";
    } else {
      this.env = "production";
    }
    // No rate conversion needed - using USD only
    this.timeVerication = this.paymentID?.created_at || new Date().toISOString();
    console.log(this.paymentID);
    const expired = new Date(this.timeVerication).getTime() + 10800000;
    this.expiredTime = new Date(expired).toLocaleString();
  },
  created() {
    this.setTimerPayment();
    this.timeUpdate = setInterval(this.setTimerPayment, 1000);
    localStorage.setItem("pageNow", "veriftimer");
  },
  methods: {
    numberWithCommas: function (params) {
      return params.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onFileSelected(e) {
      this.input_file = e.target.files[0];
      console.log(e.target.files[0]);
    },
    handleImages(files) {
      this.input_file = files[0];
    },
    find_account_name(spec_id) {
      if (spec_id == process.env.VUE_APP_API_ECN) {
        return "ECN Raw";
      }
      if (spec_id == process.env.VUE_APP_API_STANDARD) {
        return "Standard";
      }
      if (spec_id == process.env.VUE_APP_API_SYARIAH) {
        return "Syariah";
      }
    },
    onSubmitVerify() {
      const amount = `${this.paymentID?.amount || 0}`;
      var data = new FormData();
      if (this.datamethod?.method == "CRYPTO") {
        data.append("user_id", this.paymentID?.user_id || '');
        data.append("user_name", this.paymentID?.user?.name || '');
        data.append("account_id", this.paymentID?.account_id || '');
        data.append("login_id", this.login_id);
        data.append("amount", amount);
        data.append("bank_name", null);
        data.append("bank_username", null);
        data.append("attachment", this.input_file);
        data.append("submited_time", this.paymentID?.created_at || new Date().toISOString());
        data.append("expired_time", this.expiredTime);
        data.append(
          "account",
          this.find_account_name(this.paymentID?.account?.spec_id)
        );
        data.append("bank_acc", "[CRYPTO] " + this.saved_wallet);
      } else {
        data.append("user_id", this.paymentID?.user_id || '');
        data.append("user_name", this.paymentID?.user?.name || '');
        data.append("account_id", this.paymentID?.account_id || '');
        data.append("login_id", this.login_id);
        data.append("amount", amount);
        data.append("bank_name", this.paymentID?.bank?.bank_name || '');
        data.append("bank_acc", this.paymentID?.bank?.bank_acc || '');
        data.append("bank_username", this.paymentID?.bank?.bank_username || '');
        data.append("attachment", this.input_file);
        data.append("submited_time", this.paymentID?.created_at || new Date().toISOString());
        data.append("expired_time", this.expiredTime);
        data.append(
          "account",
          this.find_account_name(this.paymentID?.account?.spec_id)
        );
      }
      data.append("app_env", this.env);
      console.log(amount);
      // Prepare submission data for local database
      const submissionData = {
        userEmail: userData?.email || 'unknown@example.com',
        amount: this.paymentID?.amount || 0,
        cryptoType: this.datamethod?.crypto_type || 'USDT',
        walletAddress: this.datamethod?.wallet_address || '',
        transactionId: this.datamethod?.transaction_id || '',
        account: this.find_account_name(this.paymentID?.account?.spec_id) || '',
        appEnv: this.env,
        submittedTime: this.paymentID?.created_at || new Date().toISOString(),
        expiredTime: this.expiredTime
      };
      Swal.fire({
          title: "Deposit Verification",
          text: "Is the data correct?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((result) => {
          Notiflix.Loading.circle({
            className: "notiflix-loading",
            svgColor: "#c09a07",
          });
          if (result.isConfirmed) {
            // Save to local database
            try {
              const submissionId = cryptoDatabase.addSubmission(submissionData, this.input_file);

              Notiflix.Loading.remove();
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Verification is successful, your request is being processed by admin!",
                confirmButtonText: "Okey",
              }).then(() => {
                window.location.href = "/dashboard";
              });

              console.log('Submission saved with ID:', submissionId);
            } catch (error) {
              console.error('Submission error:', error);
              Notiflix.Loading.remove();
              Swal.fire({
                icon: "error",
                title: "Failed",
                text: error.message || "An error occurred while saving verification",
                confirmButtonText: "OK",
              });
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Notiflix.Loading.remove();
          }
        });
    },
    setTimerPayment: function (item) {
      if (!item) {
        return "00 : 00 : 00";
      }

      // waktu dibuat
      const waktuDibuat = new Date(item).getTime() + 10800000;

      // waktu sekarang
      this.timeNow = new Date().getTime();
      const selisih = waktuDibuat - this.timeNow;
      var jam = Math.floor(
        (selisih % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var menit = Math.floor((selisih % (1000 * 60 * 60)) / (1000 * 60));
      var detik = Math.floor((selisih % (1000 * 60)) / 1000);

      if (selisih > 60000) {
        return `0${jam} : ${menit} : ${detik}`;
      } else {
        return "Expired";
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timeUpdate);
  },
};
</script>

<style scoped>
.important-notice-border {
  border: 2px solid #01c906;
}
</style>